import { render, staticRenderFns } from "./ClientIndemnity.vue?vue&type=template&id=5bfd8161"
import script from "./ClientIndemnity.vue?vue&type=script&lang=js"
export * from "./ClientIndemnity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports